// extracted by mini-css-extract-plugin
export default {"mdBreak":"1024px","line":"BO0yD9T80RNKV345WgFj","phoneNumberLine":"EviQfqa9sxGzFgLZyGxk","saveButton":"hMCO_7IGx_9khuyTqc5x","countryFlag":"kSfoGlKlwYTZLaR8g3Ki"};